import { DiffSyncSchema } from "@megaron/diff-sync-contracts";

import { bcItemSerializer, shopifyProductSerialzier, shopifyProductVariantSerializer } from "./externalItems";
import { itemSerializer } from "./items";

export const catalogDiffSyncSchema = DiffSyncSchema({
  bcItem: bcItemSerializer,
  sheetsItem: itemSerializer.partial(),
  shopifyProduct: shopifyProductSerialzier.partial(),
  shopifyVariant: shopifyProductVariantSerializer.partial(),
});
